import { GET_COMPANY } from "queries/centralApi/companies";
import { clientCentralApiStrawberry } from "@neonumy/api-clients";
import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";
import useCoreStore from "./useCoreStore";

export default function useGetCompanyData() {
  const setCompanyData = useCoreStore(state => state.setCompanyData);

  const [getCompany, { refetch, loading, data: getCompanyData, error: getCompanyError }] =
    useLazyQuery<GetCompanyResponse, GetVarTypeID>(GET_COMPANY, {
      client: clientCentralApiStrawberry,
    });

  useEffect(() => {
    if (getCompanyError) onErrorGraphql(getCompanyError);
  }, [getCompanyError]);

  useEffect(() => {
    if (getCompanyData?.getCompany) {
      setCompanyData(getCompanyData.getCompany);
    }
  }, [getCompanyData]);

  return {
    getCompany,
    refetch,
    loading,
  };
}
